import type { StatusTone } from '@/components/app';

/** Статусы ценового варианта (ADR 0014) — подпись и тон для <StatusPill>. */
export const VARIANT_STATUS_LABELS: Record<string, string> = {
  draft: 'Черновик',
  active: 'Идёт набор',
  enrollment_stopped: 'Набор остановлен',
  archived: 'В архиве',
};

const TONES: Record<string, StatusTone> = {
  draft: 'neutral',
  active: 'pos',
  enrollment_stopped: 'warn',
  archived: 'neg',
};

export const variantStatusTone = (status: string | null | undefined): StatusTone =>
  (status && TONES[status]) || 'neutral';
